import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { bikeImageReload } from './actions'
import reducers from './reducers'
import initialState from './initial-state'
import historySync from './history-sync'
import firstPaintHandler from './first-paint-handler'
import { setLang, popupHandler } from './utils/i18n'
import App from './components/App'
import React from 'react'
import { RenderCustomizerOptions } from 'shared'

const customizer = (
  el: HTMLElement,
  opts: RenderCustomizerOptions = {}
): void => {
  opts.lang = opts.lang || 'en'
  const enableRedux = window.location.href.includes('localhost:4000')
  setLang(opts.lang)
  const store = configureStore({
    reducer: reducers,
    preloadedState: initialState(opts),
    devTools: enableRedux
  })

  historySync(store)
  firstPaintHandler(store)
  popupHandler(store)

  store.dispatch(bikeImageReload())

  const root = createRoot(el)
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default customizer
